enum ReportingDashboardApiTab {
  Omnichannel = 'Omnichannel',
  Google = 'Google',
  Adswizz = 'Audio',
  Dooh = 'Digital Out of Home',
  Search = 'Search',
  Social = 'Social',
  Simplifi = 'Simplifi',
  Gam = 'GAM',
}

export default ReportingDashboardApiTab;
